export default __webpack_public_path__ + "static/media/google.e327f5a7.png";